import { SocialIntent } from '../types/SocialEvent';
import type { SocialEvent } from '../types/SocialEvent';

export function getEventVisualState(event: SocialEvent): string {
  const classes: string[] = [];

  switch (event.intent) {
    case SocialIntent.BUSY:
      // Busy (Locked): Solid fill, sharp borders, high contrast. Standard DND.
      classes.push('bg-slate-900 text-white border-solid border-2 border-slate-700');
      break;

    case SocialIntent.OPEN_INVITE:
      // Open Invite: Hollow fill, pulsing border (Framer Motion).
      // Note: Pulsing logic will be handled by the component using Framer Motion, 
      // but we provide the base styling here.
      classes.push('bg-transparent border-2 border-indigo-500 text-indigo-700');
      break;

    case SocialIntent.CATALYST:
      // Catalyst: Dashed/Dotted borders, 70% opacity. "Ghost" state.
      classes.push('border-2 border-dashed border-emerald-500 text-emerald-700 opacity-70');
      // Logic: If CATALYST and currentParticipants < 2, return border-dashed opacity-70.
      if (event.currentParticipants.length < 2) {
        // Already added border-dashed and opacity-70 as base for CATALYST
      }
      break;

    case SocialIntent.SIGNAL:
      // SIGNAL (wants to do something, no specific task)
      classes.push('bg-amber-50 border-2 border-amber-400 text-amber-900');
      if (event.isDragging) {
        classes.push('animate-pulse ring-2 ring-amber-400 ring-offset-2');
      }
      break;

    case SocialIntent.BEACON:
      // Beacon: Radial gradient glow, no hard borders. Passive window.
      classes.push('bg-gradient-to-r from-purple-400 to-pink-500 text-white border-none shadow-lg shadow-purple-500/50');
      break;

    default:
      classes.push('bg-gray-100 border-gray-300 text-gray-800');
  }

  return classes.join(' ');
}
